/**
 * Application configuration derived from build-time environment variables.
 *
 * VITE_ENVIRONMENT is set in CI (see .github/workflows/deploy-marketing.yml):
 * - dev build: VITE_ENVIRONMENT=dev
 * - prod build: VITE_ENVIRONMENT=prod
 *
 * Locally (npm run dev), VITE_ENVIRONMENT is undefined, so we default to 'dev'.
 */

export type Environment = 'dev' | 'prod';

export const environment: Environment =
  (import.meta.env.VITE_ENVIRONMENT as Environment) || 'dev';

export const isDev = environment === 'dev';

/**
 * Base URL for the leads/contact API (Corp Ops Functions)
 *
 * Set via VITE_LEADS_API_URL environment variable:
 * - Local: defaults to http://localhost:7072 (via .env.local or just the fallback)
 * - CI builds: set in workflow (e.g., VITE_LEADS_API_URL=https://corp-ops-func-internal.azurewebsites.net)
 */
export const leadsApiBaseUrl =
  import.meta.env.VITE_LEADS_API_URL || 'http://localhost:7072';

/**
 * Public Azure Marketplace listing for the Corral managed application.
 *
 * This is the GA offer (`corral-managed-app`), not the earlier
 * `corral-managed-app-preview` offer — don't swap it back.
 *
 * Deliberately carries no query string: `tab=` is UI state, and `flightCodes=`
 * is the Partner Center preview-audience gate, which must not be published.
 */
export const marketplaceUrl =
  'https://marketplace.microsoft.com/en-us/product/azure-application/corral-ai.corral-managed-app';
